import React from 'react';

const Education = () => {
    return (
        <div id='education'>
            
        </div>
    );
};

export default Education;